// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context-menu_contextMenu_LV7Y4 {
  position: fixed;
  z-index: 1000;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  min-width: 130px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 0.85rem;
  text-align: left;
  background-color: var(--ui-white);
  border: 1px solid var(--ui-black-transparent);
  border-radius: 0.25rem;
  -webkit-box-shadow: 0px 0px 5px 1px var(--shadow);
          box-shadow: 0px 0px 5px 1px var(--shadow);
  transition: opacity 0.2s ease;
  z-index: var(--z-index-context-menu);
  -webkit-border-radius: 0.25rem;
  -moz-border-radius: 0.25rem;
  -ms-border-radius: 0.25rem;
  -o-border-radius: 0.25rem;
  -webkit-transition: opacity 0.2s ease;
  -moz-transition: opacity 0.2s ease;
  -ms-transition: opacity 0.2s ease;
  -o-transition: opacity 0.2s ease;
}

.context-menu_menuItem_FGont {
  padding: 8px 12px;
  white-space: nowrap;
  cursor: pointer;
  -webkit-transition: 0.1s ease;
  transition: 0.1s ease;
}

.context-menu_menuItem_FGont:hover {
  background: var(--looks-secondary);
  color: white;
}

.context-menu_menuIcon_ecuo0 {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  -webkit-flex-shrink: 0;
      -ms-flex-negative: 0;
          flex-shrink: 0;
}

.context-menu_menuLabel_UeBRE {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
      -ms-flex: 1;
          flex: 1;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/context-menu/context-menu.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,6CAA6C;EAC7C,sBAAsB;EACtB,iDAAiD;UACzC,yCAAyC;EACjD,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;MAClB,oBAAoB;UAChB,cAAc;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;MACX,WAAW;UACP,OAAO;AACjB","sourcesContent":[".contextMenu {\n  position: fixed;\n  z-index: 1000;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  min-width: 130px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  font-size: 0.85rem;\n  text-align: left;\n  background-color: var(--ui-white);\n  border: 1px solid var(--ui-black-transparent);\n  border-radius: 0.25rem;\n  -webkit-box-shadow: 0px 0px 5px 1px var(--shadow);\n          box-shadow: 0px 0px 5px 1px var(--shadow);\n  transition: opacity 0.2s ease;\n  z-index: var(--z-index-context-menu);\n  -webkit-border-radius: 0.25rem;\n  -moz-border-radius: 0.25rem;\n  -ms-border-radius: 0.25rem;\n  -o-border-radius: 0.25rem;\n  -webkit-transition: opacity 0.2s ease;\n  -moz-transition: opacity 0.2s ease;\n  -ms-transition: opacity 0.2s ease;\n  -o-transition: opacity 0.2s ease;\n}\n\n.menuItem {\n  padding: 8px 12px;\n  white-space: nowrap;\n  cursor: pointer;\n  -webkit-transition: 0.1s ease;\n  transition: 0.1s ease;\n}\n\n.menuItem:hover {\n  background: var(--looks-secondary);\n  color: white;\n}\n\n.menuIcon {\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  -webkit-flex-shrink: 0;\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n}\n\n.menuLabel {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contextMenu": `context-menu_contextMenu_LV7Y4`,
	"menuItem": `context-menu_menuItem_FGont`,
	"menuIcon": `context-menu_menuIcon_ecuo0`,
	"menuLabel": `context-menu_menuLabel_UeBRE`
};
export default ___CSS_LOADER_EXPORT___;
